var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Vue from 'vue';
import ToolBar from "../../parts/ToolBar.vue";
import PinDialog from "../../parts/PinDialog.vue";
import { PinCodeHelper, WalletsHelper } from "../../../lib/storage";
import { Environment } from "../../../lib/environment";
export default Vue.extend({
    components: { ToolBar, PinDialog },
    name: "WalletBackup",
    props: {
        id: {
            type: String,
            default: ''
        },
        lesson: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            key: "",
            showPinDialog: false
        };
    },
    methods: {
        onPassed(pin) {
            return __awaiter(this, void 0, void 0, function* () {
                const wallet = yield this.getWallet();
                if (wallet != null) {
                    this.key = (yield WalletsHelper.decryptKey(wallet.id, pin)) || "";
                }
            });
        },
        getWallet() {
            return __awaiter(this, void 0, void 0, function* () {
                if (this.id.length == 0) {
                    return yield WalletsHelper.getActive();
                }
                else {
                    return yield WalletsHelper.get(this.id);
                }
            });
        },
        goBackSettings() {
            if (Environment.isIos() && Environment.isInStandaloneMode()) {
                this.$router.push('/wallet/settings?id=' + this.id);
            }
            else {
                this.$router.go(-2);
            }
        }
    },
    mounted() {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = yield this.getWallet();
            if (wallet == null) {
                this.key = "";
            }
            else {
                if (!(yield PinCodeHelper.hasSavedCode())) {
                    this.key = wallet.decryptSecret(PinCodeHelper.defaultPin) || '';
                }
                else {
                    this.showPinDialog = true;
                }
            }
        });
    },
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/wallet/WalletBackup.vue
// module id = 635
// module chunks = 1